import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CategoryLayout from "@/components/feature/CategoryLayout";
import { categories, posts } from "@/mocks/anime";

const category = categories.find((c) => c.id === "order")!;
const list = posts.filter((p) => p.category === "order");

export default function Order() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryLayout
          category={category}
          posts={list}
          description="连载顺序、剧情顺序、时间线顺序一次理清。补番顺序攻略帮你追老番不再混乱，从入坑到毕业一站搞定。"
        />
      </main>
      <Footer />
    </>
  );
}